(() => {
  const dialog = document.getElementById('rfn-family-giveaway-popup');
  if (!dialog || dialog.dataset.initialized || window.Shopify?.designMode) return;
  dialog.dataset.initialized = 'true';
  const key = 'rfn-christmas-2026:popup-dismissed';
  const sessionKey = 'rfn-christmas-2026:popup-seen';
  let previousFocus;
  let previousOverflow;
  let previousPosition;
  let interrupted = false;
  const read = (storage, name) => { try { return window[storage].getItem(name); } catch { return null; } };
  const write = (storage, name, value) => { try { window[storage].setItem(name, value); } catch {} };
  const isClosed = () => Date.now() > Date.parse(dialog.dataset.closesAt);
  const suppressed = () => read('sessionStorage', sessionKey) || Date.now() - Number(read('localStorage', key) || 0) < 86400000;
  const markDismissed = () => {
    write('localStorage', key, String(Date.now()));
    write('sessionStorage', sessionKey, 'true');
  };
  const close = () => { markDismissed(); dialog.close(); };
  dialog.querySelector('[data-giveaway-dismiss]').addEventListener('click', close);
  dialog.querySelector('#popup-continue').addEventListener('click', close);
  dialog.addEventListener('cancel', markDismissed);
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow || '';
    if (previousFocus?.isConnected) previousFocus.focus({preventScroll: true});
    if (previousPosition) window.scrollTo({...previousPosition, behavior: 'instant'});
  });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
  });
  dialog.addEventListener('rfn:giveaway-entry', (event) => {
    if (event.detail.status !== 'success') return;
    dialog.querySelector('#popup-entry-panel').hidden = true;
    dialog.querySelector('#popup-success').hidden = false;
    dialog.querySelector('[data-popup-success-copy]').textContent = event.detail.message;
    dialog.setAttribute('aria-labelledby', 'popup-success-title');
    dialog.setAttribute('aria-describedby', 'popup-success');
    dialog.scrollTop = 0;
    markDismissed();
    if (dialog.open) dialog.querySelector('#popup-continue').focus({preventScroll: true});
  });
  document.addEventListener('focusin', (event) => {
    if (event.target.closest('[data-rfn-entry-form]')) interrupted = true;
  });
  const visible = (element) => Boolean(element && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).display !== 'none');
  const openWhenClear = (attempt = 0) => {
    if (isClosed() || suppressed() || interrupted) return;
    const blocking = document.hidden || visible(document.getElementById('shopify-pc__banner')) || document.querySelector('dialog[open], details[open] .menu-drawer, .cart-drawer.active') || /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || '');
    if (blocking) {
      if (attempt < 60) window.setTimeout(() => openWhenClear(attempt + 1), 1000);
      return;
    }
    previousFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    previousPosition = {top: window.scrollY, left: window.scrollX};
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
    dialog.scrollTop = 0;
    write('sessionStorage', sessionKey, 'true');
  };
  window.setTimeout(openWhenClear, 6000);
})();
